import { render, staticRenderFns } from "./memberCredential.vue?vue&type=template&id=b09e72a2&scoped=true"
import script from "./memberCredential.vue?vue&type=script&lang=js"
export * from "./memberCredential.vue?vue&type=script&lang=js"
import style0 from "./memberCredential.vue?vue&type=style&index=0&id=b09e72a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09e72a2",
  null
  
)

export default component.exports